import { GetServerSideProps } from "next";
import GoneNotice from "../../../../src/components/GoneNotice";
import SingleTileContainer from "../../../../src/page/HomePage/SingleTileContainer";
import { transformSingleTurfData } from "../../../../src/utils/transformSingleTurfData";
import {
  goneResult,
  lookupTurfFromRouteUsername,
  staleTurfRedirect,
} from "../../../../src/utils/publicTurfRoute";
import {
  getVisiblePitches,
  isPitchPubliclyVisible,
  isTurfPubliclyVisible,
} from "../../../../src/utils/turfVisibility";
import { formatCityName } from "../../../../src/config/cityData";

interface TurfDetailsPageProps {
  gone?: boolean;
  city?: string;
  turfusername?: string;
  pitchname?: string;
  areaName?: string | null;
  initialTurfData?: any;
}

export default function TurfDetailsPage({
  gone = false,
  city,
  turfusername,
  pitchname,
  areaName = null,
  initialTurfData = null,
}: TurfDetailsPageProps) {
  if (gone) {
    return <GoneNotice />;
  }

  if (!city || !turfusername || !pitchname) {
    return null;
  }

  return (
    <SingleTileContainer
      city={city}
      name={turfusername}
      pitchname={pitchname}
      areaName={areaName}
      initialTurfData={initialTurfData}
    />
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const city = Array.isArray(context.params?.city)
    ? context.params.city[0]
    : context.params?.city;
  const turfusername = Array.isArray(context.params?.turfusername)
    ? context.params.turfusername[0]
    : context.params?.turfusername;
  const pitchname = Array.isArray(context.params?.pitchname)
    ? context.params.pitchname[0]
    : context.params?.pitchname;

  if (!city || !turfusername || !pitchname) {
    return { notFound: true };
  }

  try {
    const turf = await lookupTurfFromRouteUsername(turfusername);
    if (!turf) {
      return { notFound: true };
    }
    if (!isTurfPubliclyVisible(turf)) {
      return goneResult(context.res);
    }

    const allPitches = Array.isArray(turf.Pitch) ? turf.Pitch : [];
    const visiblePitches = getVisiblePitches<any>(allPitches);
    const exactPitch = allPitches.find((pitch: any) => pitch.pitchName === pitchname);
    if (!visiblePitches.length || (exactPitch && !isPitchPubliclyVisible(exactPitch))) {
      return { notFound: true };
    }

    const stale = staleTurfRedirect({
      turf,
      routeCity: city,
      routeUsername: turfusername,
      routePitch: pitchname,
    });
    if (stale) {
      return { redirect: stale };
    }

    return {
      props: {
        city: city as string,
        turfusername: turf.username as string,
        pitchname: pitchname as string,
        areaName: null,
        initialTurfData: transformSingleTurfData(
          turf,
          undefined,
          formatCityName(turf.city || (city as string))
        ),
      },
    };
  } catch {
    return { notFound: true };
  }
};
